module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.674f50d2.eot";